import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddOwner from "../../../../../modals/yourAssets/BOA/CustomSubOwnersModal";
import {
  addSubOwnersValidationSchemaLoans as validationSchema,
  loans,
} from "../../../../../modals/yourAssets/BOA/helper";
import {
  addLoansInitialValues,
  shareHoldings,
} from "../../../../../modals/yourAssets/BOA/helper";
import { SecondaryButton } from "../../../../../common/Buttons";
import DeleteDataModal from "../../../../../modals/yourAssets/BOA/DeleteDataModal";

import toast, { Toaster } from "react-hot-toast";
import SimpleBarReact from "simplebar-react";
import { Typography } from "@mui/material";
import ImportData from "../ImportData";
import {
  getClientIdFromLocalStorage,
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  changeUpdateFormat,
} from "../../../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../../../constants/constants";
import ModifiedByToaster from "../../../../../common/ModifiedByToaster";
import { updateAuditTrails } from "../../../../../services/auditTrails";
import {
  getLoans,
  updateUserLoans,
} from "../../../../../services/yourAssets/Loans";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FilePreviewModal from "../../../../yourAssets/BOA/FilePreviewModal";
import DeleteFileModal from "../../../../../modals/yourAssets/BOA/DeleteFileModal";
import { deleteUserMediaBOA } from "../../../../../services/yourAssets/CommonServices";
import { handleReloadFiles } from "../../../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { getFile } from "../../../../../services/yourAssets/BankBalancesServices";
import FormattedDate from "../../../../../utils/TabelDateFormat";

const Summary = (props) => {
  let clientId = getClientIdFromLocalStorage();
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const { next } = props;
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.loans
  );
  const dispatch = useDispatch();
  const [summaryValues, handleSetSummaryValues] = useState([]);
  const [checkChanges, setCheckChanges] = useState(false);
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [showSubOwnersModal, setShowSubOwnersModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [deleteModalData, setDeleteModalData] = useState({
    object: {},
    mainUser: "",
    subUser: "",
    id: 0,
    index: 0,
  });
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);

  const getListing = async () => {
    let result = await getLoans(id);
    if (result?.success) {
      let list = result?.payLoad;
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const elementI = list[i];
        let mainObj = {
          currentStatus: elementI?.currentStatus,
          borrower: elementI?.name,
          id: elementI?.loanId,

          owner: {
            currentStatus: elementI?.currentStatus,
            borrower: elementI?.name,
            interestRate: elementI?.interestRate,
            fixedInterestRate: elementI?.fixedInterestRate,
            forWhat: elementI?.forWhat,
            creditInstitution: elementI?.creditInstitution,
            accountNumber: elementI?.accountNumber,
            id: elementI?.loanId,
            subOwners: [],
          },
        };
        for (let j = 0; j < elementI.subLoans.length; j++) {
          const elementJ = elementI.subLoans[j];
          elementJ.id = elementJ.subLoanId;
          elementJ.loanId = elementI.loanId;
          elementJ["borrower"] = elementJ.name;

          delete elementJ.subLoanId;
        }
        mainObj.owner.subOwners = elementI.subLoans;
        array.push(mainObj);
      }
      handleSetSummaryValues(array);
    }
  };
  const handleUpdates = async (data) => {
    await updateAuditTrails(data, id);
  };

  useEffect(() => {
    setUpdatedIds(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[7] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[7]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[7] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[7]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[7] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[7]?.toLowerCase()
        )
        .map((item) => item)
    );
  }, []);
  useEffect(() => {
    setCheckChanges(false);
    getListing();
  }, [checkChanges]);
  const handleAddOwner = async (values) => {
    if (selectedRow?.type === "owner") {
      if (selectedRow.behaviour === "create") {
        const { borrower } = values;
        delete values.borrower;
        handleSetSummaryValues([
          ...summaryValues,
          {
            borrower: borrower,
            id: summaryValues.length + 1,
            currentStatus: values.currentStatus,
            owner: {
              ...values,
              borrower,
              id: summaryValues.length + 1,
              subOwners: [],
            },
          },
        ]);
      } else {
        const { borrower } = values;
        delete values.borrower;
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id) {
              return {
                ...item,
                borrower: borrower,
                currentStatus: values.currentStatus,
                owner: {
                  ...item.owner,
                  borrower,
                  ...values,
                  id: item.id,
                },
              };
            }
            return { ...item };
          })
        );
      }
    } else {
      if (selectedRow.behaviour === "create") {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item.owner?.subOwners
                    ? [
                        ...item.owner.subOwners,
                        {
                          ...values,
                          id:
                            item.owner?.subOwners?.length === 0
                              ? 1
                              : item.owner?.subOwners?.length + 1,
                        },
                      ]
                    : [
                        {
                          ...values,
                          id:
                            item.owner?.subOwners?.length === 0
                              ? 1
                              : item.owner?.subOwners?.length + 1,
                        },
                      ],
                },
              };
            return { ...item };
          }) || []
        );
      } else {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item?.owner?.subOwners?.map((subowner, index) => {
                    if (initialValues.id === subowner.id) {
                      return {
                        ...values,
                        id: subowner?.id,
                        loanId: subowner?.loanId,
                      };
                    }
                    return subowner;
                  }),
                },
              };
            return { ...item };
          }) || []
        );
      }
    }
  };
  const handleMainSubmit = async () => {
    setBtnLoading(true);
    let array = [];

    for (let i = 0; i < summaryValues.length; i++) {
      const elementI = summaryValues[i];
      let mainObj = {
        loanId: elementI.id?.length > 10 ? elementI.id : "",
        currentStatus: elementI.currentStatus,
        name: elementI.owner.borrower,
        interestRate: elementI.owner.interestRate,
        fixedInterestRate: elementI.owner.fixedInterestRate,
        forWhat: elementI.owner.forWhat,
        creditInstitution: elementI.owner.creditInstitution,
        accountNumber: elementI.owner.accountNumber,
        subLoans: [],
      };
      for (let index = 0; index < elementI.owner.subOwners?.length; index++) {
        const elementJ = elementI.owner.subOwners[index];
        elementJ["subLoanId"] = elementJ.id?.length > 10 ? elementJ.id : "";
        elementJ["name"] = elementJ.borrower || "";
        elementJ["loanId"] =
          elementJ?.loanId?.length > 10 ? elementJ?.loanId : "";
        delete elementJ.id;
      }
      mainObj.subLoans = elementI.owner.subOwners;
      array.push(mainObj);
    }
    let result = await updateUserLoans(array, id);
    if (result?.success) {
      setCheckChanges(true);
      next();
    } else {
      toast.error(result?.message);
    }
    setBtnLoading(false);
  };

  const handleSubOwnersModalOpen = () => {
    setShowSubOwnersModal(true);
  };

  const handleSubOwnersModalClose = () => {
    setSelectedRow(null);
    setShowSubOwnersModal(false);
  };
  const handleSetSelectedRow = (item, type, behaviour = "create") => {
    setSelectedRow({ ...item, type, behaviour });
  };
  const getInitialValues = () => {
    if (initialValues !== null) {
      return {
        currentStatus: initialValues?.currentStatus
          ? initialValues.currentStatus
          : "",
        borrower: initialValues?.borrower ? initialValues?.borrower : "",
        interestRate: initialValues?.interestRate
          ? initialValues?.interestRate
          : "",
        fixedInterestRate: initialValues?.fixedInterestRate
          ? initialValues?.fixedInterestRate
          : "",
        forWhat: initialValues?.forWhat ? initialValues?.forWhat : "",
        creditInstitution: initialValues?.creditInstitution
          ? initialValues?.creditInstitution
          : "",
        accountNumber: initialValues?.accountNumber
          ? initialValues?.accountNumber
          : "",
      };
    }
    return addLoansInitialValues;
  };

  const handleDeleteOwner = (type, id, index) => {
    if (type === "owner") {
      handleSetSummaryValues(
        summaryValues.filter((item, itemIndex) => itemIndex !== index)
      );
      summaryValues.forEach((item, itemIndex) => {
        if (itemIndex === index)
          return {
            nameOfOwner: item.companyName,
            id: item.id,
          };
        return item;
      });
    } else {
      handleSetSummaryValues(
        summaryValues.map((item, itemIndex) => {
          if (itemIndex === index)
            return {
              ...item,
              owner: {
                ...item.owner,
                subOwners: item.owner.subOwners.filter(
                  (subOwner) => subOwner.id !== id
                ),
              },
            };
          return item;
        })
      );
    }
  };

  const handleDeleteDataModal = (object, mainUser, subUser, id, index) => {
    let obj = {
      object,
      mainUser,
      subUser,
      id,
      index,
    };
    setDeleteModalData(obj);
    setDeleteDataModal(true);
  };
  const handleDeleteData = () => {
    handleSetSelectedRow(deleteModalData.object, deleteModalData.mainUser);
    handleDeleteOwner(
      deleteModalData.subUser,
      deleteModalData.id,
      deleteModalData.index
    );
  };
  const totalValue = () => {
    let count = 0;
    summaryValues.forEach((el) => {
      if (el.owner.currentStatus) {
        count += +el.owner.currentStatus;
      }
    });
    return count.toLocaleString("de-DE");
  };

  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: clientId,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(clientId, boaUserMediaFileId);
    if (result?.success) {
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
    }
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);
  return (
    <React.Fragment>
      <Toaster />
      {showSubOwnersModal && (
        <AddOwner
          open={showSubOwnersModal}
          handleOpen={handleSubOwnersModalOpen}
          handleClose={handleSubOwnersModalClose}
          handleDelete={() => {}}
          handleSubmit={handleAddOwner}
          type={selectedRow && selectedRow.type}
          id={selectedRow && selectedRow.id}
          selectedRow={selectedRow ? selectedRow : null}
          getInitialValues={getInitialValues}
          enteries={loans(t)}
          validationSchema={validationSchema(t)}
          user={userName}
          companyName={selectedRow.companyName}
          tabName={t("loans")}
        />
      )}
      <DeleteDataModal
        open={deleteDataModal}
        handleClose={() => {
          setDeleteDataModal(false);
        }}
        handleDelete={handleDeleteData}
        newFlow={true}
        user={deleteModalData?.object?.currentStatus}
      />
      <Box className="shareholdings-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <SecondaryButton
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: "1.5rem",
                      position: "absolute",
                      left: "7%",
                    }}
                  >
                    +
                  </Typography>{" "}
                  {t("add-line")}
                </>
              }
              border="none"
              textTransform="initial"
              fontWeight="normal"
              bgColor="color.magentaLight2"
              borderRadius="40px"
              padding="2px auto"
              minWidth="235px"
              marginLeft="20px"
              hoverBgColor="color.magentaLight1"
              click={() => {
                setInitialValues(null);
                setShowSubOwnersModal(true);
                setSelectedRow({ type: "owner", behaviour: "create" });
                setUserName("Shareholding");
              }}
            />
            <ImportData
              sectionId={10}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          {/* <SimpleBarReact style={{ maxHeight: 300 }} autoHide={false}> */}
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{
                "th , td": { border: "none" },
              }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {t(getKeyFromText("Current status"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Borrower"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Interest rate"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Fixed interest rate"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("For what"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Credit institution"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Account number"))}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryValues.map((item, index) => (
                  <>
                    <TableRow
                      sx={{
                        backgroundColor: `${
                          index % 2 === 0 ? "color.smokeWhite" : "color.white"
                        }`,
                      }}
                      className={
                        updatedIds.includes(item.id)
                          ? "highlighted-table-row"
                          : ""
                      }
                    >
                      <TableCell>
                        {item?.currentStatus
                          ? Number(item.currentStatus).toLocaleString("de-DE") +
                            " €"
                          : "-"}
                        {/* {item?.currentStatus ? item.currentStatus : "-"} */}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {item?.owner?.borrower ? (
                            <>
                              {item.owner.borrower}{" "}
                              {
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="Add"
                                  size="small"
                                  onClick={() => {
                                    setInitialValues({
                                      ...addLoansInitialValues,
                                    });
                                    setUserName(item.owner.nameOfOwner);
                                    handleSubOwnersModalOpen();
                                    handleSetSelectedRow(item, "subOwner");
                                  }}
                                >
                                  <AddCircleOutlineSharpIcon />
                                </IconButton>
                              }
                            </>
                          ) : (
                            "-"
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {item?.owner?.interestRate
                          ? item.owner.interestRate + "%"
                          : "-"}
                      </TableCell>

                      <TableCell>
                        <FormattedDate
                          date={item?.owner?.fixedInterestRate}
                          language={i18n.language}
                        />
                        {/* {item?.owner?.fixedInterestRate
                          ? item.owner.fixedInterestRate
                          : "-"} */}
                      </TableCell>
                      <TableCell>
                        {item?.owner?.forWhat ? item.owner.forWhat : "-"}
                      </TableCell>
                      <TableCell>
                        {item?.owner?.creditInstitution
                          ? item.owner.creditInstitution
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {item?.owner?.accountNumber
                          ? item.owner.accountNumber
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {/* {item?.owner?.borrower && ( */}
                        {
                          <>
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="add"
                              size="small"
                              onClick={() => {
                                handleSetSelectedRow(item, "owner", "edit");
                                setInitialValues({
                                  borrower: item.borrower,
                                  ...item.owner,
                                });
                                setUserName(item.owner.borrower);
                                handleSubOwnersModalOpen();
                              }}
                            >
                              <img
                                src="/assets/icons/edit-icon.svg"
                                alt="edit"
                              />
                            </IconButton>
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="delete"
                              size="small"
                              onClick={() => {
                                handleDeleteDataModal(
                                  item,
                                  "owner",
                                  "owner",
                                  item.id,
                                  index
                                );
                                setUserName(item.borrower);
                              }}
                            >
                              <img
                                src="/assets/icons/delete-icon.svg"
                                alt="delete"
                              />
                            </IconButton>
                          </>
                        }
                      </TableCell>
                    </TableRow>
                    {item?.owner?.subOwners?.length > 0 &&
                      item.owner.subOwners.map((owner, ownerIndex) => {
                        return (
                          <TableRow
                            key={owner?.id}
                            sx={{
                              backgroundColor: `${
                                index % 2 === 0
                                  ? "color.smokeWhite"
                                  : "color.white"
                              }`,
                            }}
                            className={
                              updatedIds.includes(owner?.id)
                                ? "highlighted-table-row"
                                : ""
                            }
                          >
                            <TableCell></TableCell>
                            <TableCell>{owner.borrower}</TableCell>
                            <TableCell>{owner.interestRate}</TableCell>
                            <TableCell>
                              {owner?.fixedInterestRate
                                ? owner.fixedInterestRate
                                : "-"}
                            </TableCell>

                            <TableCell>
                              {owner?.forWhat ? owner.forWhat : "-"}
                            </TableCell>

                            <TableCell>
                              {owner?.creditInstitution
                                ? owner.creditInstitution
                                : "-"}
                            </TableCell>

                            <TableCell>
                              {owner?.accountNumber ? owner.accountNumber : "-"}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="add"
                                size="small"
                                onClick={() => {
                                  handleSetSelectedRow(
                                    item,
                                    "subOwner",
                                    "edit"
                                  );
                                  setInitialValues({
                                    borrower: item.borrower,
                                    ...owner,
                                  });
                                  setUserName(owner.borrower);
                                  handleSubOwnersModalOpen();
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  handleDeleteDataModal(
                                    item,
                                    "owner",
                                    "subOwner",
                                    owner.id,
                                    index
                                  );
                                  setUserName(item.borrower);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </>
                ))}
                <TableRow sx={{ background: "#dfc8db" }}>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                    align="left"
                  >
                    {t("total")} &nbsp; {`  ${totalValue()} € `}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>

                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* </SimpleBarReact> */}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={handleMainSubmit}
            textTransform="initial"
            disabled={btnLoading}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </React.Fragment>
  );
};

export default Summary;
